import { Col, Row } from 'rsuite';
import styled from 'styled-components';

export const Content = styled.div`
  width: 100%;
  padding: 0 20px 20px;
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 16px 0 4px;
`;

export const SectionTitle = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text};
`;

export const DragHint = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const StyledRow = styled(Row)`
  display: flex;
  align-items: center;
  background-color: transparent;
  padding: 4px 12px;
  border-radius: 10px;
  margin-bottom: 4px;
`;

export const StyledCol = styled(Col)`
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const ContainerSize = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 2px;
  padding-bottom: ${({ hasTamanhos }) => (hasTamanhos ? 0 : '50px')};

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.lightGray};
    border-radius: 10px;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 20px;
  background-color: ${({ theme }) => theme.colors.backgroundSecondary};
  border-radius: 12px;
  border: 2px dashed ${({ theme }) => theme.colors.lightGray};
  text-align: center;
  margin-top: 4px;
`;

export const EmptyStateTitle = styled.p`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text};
`;

export const EmptyStateText = styled.p`
  margin: 6px 0 0;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const SaveSequence = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
`;
